import React, { useEffect, useContext} from "react";
import CartWidget from '../cart/CartWidget';
import logo from '../../Css/logo.svg';
import {Link, NavLink } from 'react-router-dom';
import { UserContext } from '../../context/UserProvider';
import { logOut } from '../../Firebase/Firebase';
import './NavBar.css'


// Muestra el menu de navegacion para desplazarce por las distintas secciones o categoria  de la web, tambien el logOut 

const NavBar = () => {
	const {inicioS} = useContext(UserContext)

	useEffect(() => {
	}, [inicioS])

    return(
        <header className="menuBarra">
			<Link to={'/'}><img src={logo} className="imgLogo" alt="logo"/></Link>
            <h2 className="marca">
                <a href="/"><span>F&N</span>Shop</a>
            </h2>
            <nav className="nav" >
				<div>  
					<ul className="navbar-left">
						<li>
							<NavLink to={'/'} exact activeClassName='active'>Inicio</NavLink>
						</li>
						<li className="nav-item dropdown">
							<NavLink to={'/category'} activeClassName='active'><div className="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Catalogo</div></NavLink>
							<div className="dropdown-menu">
								<Link to={'/category/pelotas'} className="dropdown-item">Pelota</Link>
								<Link to={'/category/correas'} className="dropdown-item" href="#">Correas</Link>
								<Link to={'/category/camas'} className="dropdown-item" href="#">Camas</Link>
								<Link to={'/category/otros'} className="dropdown-item" href="#">Otros</Link>
							</div>
						</li>
						<li>
							<NavLink to={'/contacto'} exact activeClassName='active' ><i className="fas fa-file-signature "></i>Contacto</NavLink>
						</li>
						<li>
							{inicioS && <Link to={'/'}><button className="btn logout" onClick={()=>logOut()}>
								<span> logout</span>
							</button></Link>}
						</li>
					</ul>
                    <CartWidget/>

				</div>	 
			</nav>
        </header>
    );
      
}

export default NavBar;